import React from 'react';
import cx from 'classnames';
import { useDispatch } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Button } from 'react-bootstrap';

import Loader from '../Common/Loader/Loader';

import messages from '../../locale/messages';
import { closeHeaderModal } from '../../actions/siteadmin/modalActions';
import { cancelScheduleBookingAction } from '../../actions/booking/cancelScheduleBookingAction';

import bt from '../../components/commonStyle.css';

const CancelScheduleBookForm = ({ formData, intl: { formatMessage } }) => {

    const dispatch = useDispatch()
    const loading = useSelector(state => state.loader.cancelSchedule)
    const handleClick = async () => {
        dispatch(cancelScheduleBookingAction({
            bookingId: formData?.bookingId,
            requestCurrency: formData?.currency,
            currentPage: formData?.currentPage,
        }));
    };

    const handleClose = () => {
        dispatch(closeHeaderModal('cancelScheduleBooking'));
    };

    return (
        <>
            <div className={cx(bt.commonSize14, bt.fontWeight400, bt.primaryColor, bt.textAlignStart)}>
                <FormattedMessage {...messages.cancelSchedule} />
            </div>
            <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                <Button onClick={handleClose} className={bt.btnSecondary}>
                    <FormattedMessage {...messages.cancelButton} />
                </Button>
                <Loader
                    type="button"
                    buttonType="button"
                    show={loading}
                    handleClick={handleClick}
                    label={formatMessage(messages.confirm)}
                    className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                />
            </div>
        </>
    );
};

export default injectIntl(withStyles(bt)(CancelScheduleBookForm));